import React, { useState } from 'react';
import { LoginForm } from './LoginForm';
import { RegisterForm } from './RegisterForm';
import { AuthShell } from './AuthShell';

interface AuthLayoutProps {
  onSuccess?: () => void;
  defaultMode?: 'login' | 'register';
}

export const AuthLayout: React.FC<AuthLayoutProps> = ({ onSuccess, defaultMode = 'login' }) => {
  const [currentMode, setCurrentMode] = useState<'login' | 'register'>(defaultMode);

  const handleSuccess = () => {
    onSuccess?.();
  };

  return (
    <AuthShell>
      {currentMode === 'login' ? (
        <LoginForm
          onSignUpClick={() => setCurrentMode('register')}
          onSuccess={handleSuccess}
        />
      ) : (
        <RegisterForm
          onSignInClick={() => setCurrentMode('login')}
          onSuccess={handleSuccess}
        />
      )}
    </AuthShell>
  );
};
